export default __webpack_public_path__ + "static/media/NotoSans-SemiBold.0781f722.woff2";